import React, { useState } from "react";
import axiosInstance from "../../../../../services/AxiosInstance";
import swal from "sweetalert";

const CATEGORIAS_URL = "/api/v3/zonas-sociales/activos/categorias/";

const CategoriaCreateModal = ({ show, onHide, onSuccess }) => {
    const [nombre, setNombre] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!nombre.trim()) {
            swal("Validación", "El nombre de la categoría es obligatorio.", "warning");
            return;
        }

        setLoading(true);
        try {
            const payload = { nombre: nombre.trim() };
            const response = await axiosInstance.post(CATEGORIAS_URL, payload);
            swal("Éxito", "Categoría creada correctamente.", "success");
            setNombre("");
            if (onSuccess) onSuccess(response.data);
            onHide();
        } catch (error) {
            swal(
                "Error",
                "No fue posible crear la categoría. Verifica que no exista ya.",
                "error",
            );
        } finally {
            setLoading(false);
        }
    };

    if (!show) return null;

    return (
        <>
            <div
                className="modal fade show"
                style={{ display: "block", zIndex: 1060 }}
                tabIndex="-1"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Nueva Categoría</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onHide}
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="cat-nombre" className="form-label">
                                        Nombre <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="cat-nombre"
                                        value={nombre}
                                        onChange={(e) => setNombre(e.target.value)}
                                        autoFocus
                                    />
                                </div>
                                <div className="d-flex justify-content-end gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={onHide}
                                        disabled={loading}
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary text-white"
                                        disabled={loading}
                                    >
                                        {loading ? "Guardando..." : "Guardar"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="modal-backdrop fade show"
                style={{ zIndex: 1050 }}
                onClick={onHide}
            />
        </>
    );
};

export default CategoriaCreateModal;
